import { render, staticRenderFns } from "./RoomScreenDetailV3.vue?vue&type=template&id=5411b7e2&scoped=true&"
import script from "./RoomScreenDetailV3.vue?vue&type=script&lang=js&"
export * from "./RoomScreenDetailV3.vue?vue&type=script&lang=js&"
import style0 from "./RoomScreenDetailV3.vue?vue&type=style&index=0&id=5411b7e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5411b7e2",
  null
  
)

component.options.__file = "RoomScreenDetailV3.vue"
export default component.exports